export default __webpack_public_path__ + "static/SSSpyView_screenshot-1-3f1d18938fa79b0c76f4170721f4beaa.webp";